import React, { useEffect, useMemo } from "react";
import "./SecondHeader.scss";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAppDispatch, useTypedSelector } from "../../../store/app.store.tsx";
import { Select } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import {
  fetchFacilities,
  setSelectedFacility,
} from "../../../store/facilities.reducer.tsx";
import { Facility } from "../../../interfaces/facility.interface.tsx";

export interface SecondHeaderProps {
  updateFacility: (val: string) => void;
  email: string;
  token: string;
  isDemoMode: boolean;
  onToggleSideNav?: () => void;
}

export const SecondHeader = (props: SecondHeaderProps) => {
  const { email, token, onToggleSideNav, isDemoMode } = props;
  const dispatch = useAppDispatch();
  const location = useLocation();
  const facilities: Facility[] = useTypedSelector(
    (state) => state.facility.facilities
  ) as Facility[];
  const loading = useTypedSelector((state) => state.facility.loadingFacilities);
  const selectedFacility = useTypedSelector(
    (state) => state.facility.selectedFacility
  );

  // Determine facility type based on URL
  const facilityType = useMemo(() => {
    const path = location.pathname.toLowerCase();
    if (path.includes('dashboard/cisp')) {
      return 'L';
    }
    else if(path.includes('dashboard/tower-tracon') || path.includes('dashboard/atcscc')
            || path.includes('dashboard/artcc') || path.includes('dashboard/fss')) {
      return 'ACFT';
    }

    return null;
  }, [location.pathname]);

  useEffect(() => {
    dispatch(fetchFacilities({ email, token, type: facilityType }));
  }, [dispatch, email, token, facilityType]);

  const isActiveLink = (url: string): boolean => {
    return window.location.href.endsWith(url);
  };

  if (loading) {
    return null;
  }

  return (
    <div className="second-header">
      <div className="header-left">
        <button
          className="nav-toggle-btn"
          onClick={onToggleSideNav}
          aria-label="Toggle navigation"
        >
          <MenuOutlined />
        </button>

        <Link to="/home" className="header-link">
          Home
        </Link>
      </div>
      {isDemoMode && (
        <div className="demo-mode-indicator">
          <span>Demo Mode</span>
        </div>
      )}
      <nav>
        <ul>
          <li>
            <NavLink
              to="/dashboard"
              className={
                isActiveLink("/dashboard")
                  ? "header-link active-link"
                  : "header-link"
              }
            >
              Dashboards
            </NavLink>
          </li>
          {facilities && facilities.length > 0 && (
            <li>
              <Select
                showSearch
                value={selectedFacility}
                className="facility-select"
                onChange={(value) => dispatch(setSelectedFacility(value))}
                options={
                  facilities.map((facility: Facility) => ({
                    value: facility.site_id,
                    label: `${facility.site_id} - ${facility.site}`,
                  })) as any
                }
              />
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};
